import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { Multitenant } from '../../services/multitenant.provider';
import { AuthProvider } from '../../services/auth.provider';
import { ArticlesService } from '../../services/articles.service';
import { MetaProvider } from '../../services/meta.provider';
import { PopUpService } from '../../shared/components/pop-up/pop-up.service';
import { PopUp } from '../../models/popup.model';

@Component({
  selector: 'app-thematicfiles',
  templateUrl: 'thematicfiles.html',
  styleUrls: ['thematicfiles.scss']
})
export class ThematicfilesPage {
  public authenticated: boolean;
  public newspapers: Array<any>;
  public thematicFiles: Array<any>;
  public themeClass: string;
  public isActivePage: string;
  public popup: PopUp = new PopUp();
  public tempPopUp: boolean;
  private theme: any;
  private dossierspage = false;

  constructor(
    private router: Router,
    private multiTenant: Multitenant,
    private auth: AuthProvider,
    private service: ArticlesService,
    private meta: MetaProvider,
    private popUpService: PopUpService
  ) { }

  ionViewWillEnter() {
    let news: Array<any>;
    const newspapers: Array<any> = [];
    this.themeClass = this.multiTenant.getDomainClass();
    this.authenticated = this.auth.isAuthenticated();
    if (this.auth.isAuthenticated() && this.auth.hasAccessToMain()) {
      news = this.auth.hasAccessToMain().split(',');
    }

    if (!this.auth.isAuthenticated()) {
      news = ['lepq', 'mquo', 'actu', 'aeco'];
    }

    if (news) {
      news.forEach( (item) => {
        if (item === 'lepq') {
          newspapers.push({ class: 'lepq', age: 'Pour les 7-10 ans' });
        }
        if (item === 'mquo') {
          newspapers.push({ class: 'mquo', age: 'Pour les 10-13 ans' });
        }
        if (item === 'actu') {
          newspapers.push({ class: 'actu', age: 'Pour les 13-20 ans' });
        }
        if (item === 'aeco') {
          newspapers.push({ class: 'aeco', age: 'Pour les 15-20 ans' });
        }
      });
    }

    this.newspapers = newspapers;
    this.isActivePage = 'dossiers';
  }

  ionViewDidEnter() {
    this.meta.clearHead();
    this.meta.setMetaData('dossiers', 'playbacpresse');

    /* UnIdentified pop-up show */
    if (!this.auth.isAuthenticated() && this.popUpService.havePassedSevenDays() && this.multiTenant.getDomainClass() === 'playbacpresse') {
      this.tempPopUp = true;
      this.popup.type = 'unIdentifiedUser';
    }
    /* UnIdentified pop-up show */
  }

  goToThematicFiles(newspaper: string) {
    this.service.getThematicFilesCategories(newspaper).subscribe((response) => {
      if (response[0].name === 'Général') {
        this.dossierspage = true;
        this.theme = response[0];
        if (this.dossierspage) {
          this.router.navigate( ['dossiers-actualite', newspaper, this.theme.slug]);
        }
      } else {
        this.dossierspage = false;
        this.router.navigate(['dossiers-actualite', newspaper]);
      }
    });
  }
}
